import {Fragment} from 'react';
import {TableCell} from '@mui/material';
import {ICustomerGuid} from '@mybake/ui/models/Customers/ICustomerGuid';

interface Props {
    row: ICustomerGuid;
}

export const CustomerCard = ({row}: Props) => (
    <Fragment>
        <TableCell>{row.name || [row.firstName, row.lastName].filter(Boolean).join(' ')}</TableCell>
    </Fragment>
);
